import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    branchReviewStatus: "PENDING",
    voicebotHasNoPhoneNo: true,
};
const adminSlice = createSlice({
    name: "admin",
    initialState,
    reducers: {
        setBranchReviewStatus(state, action) {
            state.branchReviewStatus = action.payload;
        },
        setVoicebotHasNoPhoneNo(state, action) {
            state.voicebotHasNoPhoneNo = action.payload;
        },
    },
});
export const { setBranchReviewStatus, setVoicebotHasNoPhoneNo } = adminSlice.actions;
export default adminSlice.reducer;
export const adminSelector = (state) => state.admin;
